import { useContext, useEffect } from "react";
import { Context } from "Context";
import InlineErrors from "components/shared/InlineErrors";
import InlineDescription from "components/shared/InlineDescription";
import "@wdpr/datepicker";
import { getTransformedDate } from "utils/date";

const InputDatePicker = ({
	id,
	label,
	name,
	required,
	requiredText = "",
	description,
	value = "",
	minEnabledDays,
	maxEnabledDays,
	handleChange,
	validateInput,
	validateInputDate,
	notEmptyMessage,
	inlineErrors,
	showInlineErrors = true,
	isMobileView,
	format = "MM/dd/yyyy",
	invalidFormatErrorMessage,
}) => {
	const mainClass = "help-input-date-picker";
	const additionalProps = {};

	format = format.replace("YYYY", "yyyy").replace("DD", "dd");

	const {
		config: { currentLocale },
	} = useContext(Context);

	useEffect(() => {
		const selectedDateHandler = (event) => {
			handleChange &&
				handleChange({
					target: { name, value: event?.detail?.selectedDate, type: "date" },
				});
			validateInputDate &&
				validateInputDate(
					name,
					!!event?.detail?.selectedDate,
					invalidFormatErrorMessage
				);
		};

		document
			.getElementById(id)
			?.addEventListener("selected-date", selectedDateHandler);
		return () => {
			window.removeEventListener("selected-date", selectedDateHandler);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const wdprInputClasses = document
		.getElementById(id)
		?.shadowRoot?.querySelector("wdpr-input")?.classList;
	if (inlineErrors?.[id]) {
		wdprInputClasses?.add("invalid");
		additionalProps.invalid = true;
	} else {
		wdprInputClasses?.remove("invalid");
		delete additionalProps.invalid;
	}

	return (
		<div className={`${mainClass}${value ? ` ${mainClass}--has-value` : ""}`}>
			{description?.modalContent && (
				<InlineDescription
					{...description}
					isMobileView={isMobileView}
					position="top"
				/>
			)}
			<wdpr-datepicker
				id={id}
				variant="editable-input"
				text-input-placeholder={`${label}${required ? "*" : ""}`}
				format={format}
				editable-format-label={format}
				input-label={label}
				min-enabled-date={getTransformedDate(-minEnabledDays, format)}
				max-enabled-date={getTransformedDate(maxEnabledDays, format)}
				validate-after-complete="true"
				onBlur={() => {
					!inlineErrors?.[id] &&
						required &&
						notEmptyMessage &&
						validateInput &&
						validateInput(name, value, required, notEmptyMessage);
				}}
				locale={currentLocale?.split("-")[0]}
				required={required}
				{...additionalProps}
			></wdpr-datepicker>
			{inlineErrors && showInlineErrors && (
				<InlineErrors validate={id} errorMessages={inlineErrors} />
			)}
			{description?.text && (
				<InlineDescription
					{...description}
					isMobileView={isMobileView}
					position="bottom"
				/>
			)}
		</div>
	);
};

export default InputDatePicker;
